import { JsonConvert } from 'json2typescript';

import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CommonApproveModel } from '../model/common-approve-model';
import { KovanTaskModel } from 'ui-shared';
import { HvlResponse } from '@hvlng/framework-bff/core';
import { map } from 'rxjs/operators';
import { HrConfigurationService } from './hr.configuration.service';

@Injectable({
    providedIn: 'root',
})
export class BpmnCommonApproveService {
    endpoint: string;

    constructor(
        private httpClient: HttpClient,
        private configService: HrConfigurationService,
    ) {
        this.endpoint = configService.config.hr.personnel;
    }

    public updateStatus(commonApproveModel: CommonApproveModel, customEndpoint?: string): Observable<any> {
        const pattern = '/bpmnCommonApproveService/bpmnCommonApprove';
        const converter = new JsonConvert();
        const baseUrl = customEndpoint ? customEndpoint : this.endpoint;
        return this.httpClient.post<void>(
            baseUrl + pattern,
            converter.serialize(commonApproveModel, CommonApproveModel),
        );
    }
    public getTaskModelByBusinessKeyAndProcessDefinitionKey(
        businessKey: string,
        processDefinitionKey: string,
    ): Observable<KovanTaskModel> {
        const pattern =
            '/bpmnCommonApproveService/bpmnCommonApprove/getTaskModelByBusinessKeyAndProcessDefinitionKey/' +
            businessKey +
            '/' +
            processDefinitionKey;
        const converter = new JsonConvert();
        return this.httpClient.get<HvlResponse<KovanTaskModel>>(this.endpoint + pattern).pipe(
            map((data) => {
                return converter.deserializeObject(data.body, KovanTaskModel);
            }),
        );
    }
}
